import ChangePassword from 'app/pages/ChangePassword';
import CompanyManager from 'app/pages/CompanyManager';
import { HomePage } from 'app/pages/HomePage';
import RegisterMultilingualDictionary from 'app/pages/RegisterMultilingualDictionary';
import ServiceManager from 'app/pages/ServiceManager';
import SupperAminProfile from 'app/pages/SupperAminProfile';
import UserManager from 'app/pages/UserManager';
import UserPaymentHistory from 'app/pages/UserPaymentHistory';
import UserPaymentManager from 'app/pages/UserPaymentManager';
import UserProfile from 'app/pages/UserProfile';
import UserServiceManager from 'app/pages/UserServiceManager';
import { ROLE } from 'constant/user';

import {
  iconDashboard,
  userMenu,
  serviceMenu,
  profileIcon,
  myCompanyIcon,
  paymentMenuIcon,
  multilingualIconMenu,
  iconLastused,
} from 'images';

export const router = {
  login: '/login',
  sign_up: '/signup',
  home: '/',
  not_found_page: '/404',
};

export const menuConfig = {
  // common
  dashboard: {
    router: '/',
    label: 'Dashboard',
    icon: iconDashboard,
    component: HomePage,
    role: [ROLE.superAdmin, ROLE.user],
  },
  change_password: {
    router: '/change-password',
    label: 'Change Password',
    icon: iconLastused,
    component: ChangePassword,
    role: [ROLE.superAdmin, ROLE.user],
  },
  // supper admin router
  supper_admin_profile: {
    router: '/supper-admin-profile',
    label: 'My Profile',
    icon: profileIcon,
    component: SupperAminProfile,
    role: [ROLE.superAdmin],
  },
  user: {
    router: '/user-manager',
    label: 'User',
    icon: userMenu,
    component: UserManager,
    role: [ROLE.superAdmin],
  },
  service: {
    router: '/service-manager',
    label: 'Service',
    icon: serviceMenu,
    component: ServiceManager,
    role: [ROLE.superAdmin],
  },
  multilingual: {
    router: '/multilingual-manager',
    label: 'Multilingual',
    icon: multilingualIconMenu,
    component: RegisterMultilingualDictionary,
    role: [ROLE.superAdmin],
  },
  // user router
  user_profile: {
    router: '/user-profile',
    label: 'My Profile',
    icon: profileIcon,
    component: UserProfile,
    role: [ROLE.user],
  },
  company: {
    router: '/my-company',
    label: 'My Company',
    icon: myCompanyIcon,
    component: CompanyManager,
    role: [ROLE.user],
  },
  user_service: {
    router: '/user-service',
    label: 'Service',
    icon: serviceMenu,
    component: UserServiceManager,
    role: [ROLE.user],
  },
  user_payment: {
    router: '/user-payment',
    label: 'Subscribe',
    icon: paymentMenuIcon,
    component: UserPaymentManager,
    role: [ROLE.user],
  },
  user_payment_history: {
    router: '/user-payment-history',
    label: 'Payment History',
    icon: paymentMenuIcon,
    component: UserPaymentHistory,
    role: [ROLE.user],
  },
};
